import { render } from "./EvatyViewComponent.vue?vue&type=template&id=9530a618"
import script from "./EvatyViewComponent.vue?vue&type=script&lang=js"
export * from "./EvatyViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hosts.evaty.net/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__